import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import * as moment from 'moment';

import { CheckMotoService } from '../../services/check-moto.service';

@Component({
  selector: 'app-checkmotoprint',
  templateUrl: './checkmotoprint.component.html',
  styleUrls: ['./checkmotoprint.component.css']
})
export class CheckmotoprintComponent implements OnInit {
  public checklist = {
    'cliente': {
      'cliente_nome': ''
    },
    'unidade': {
      'unidade_nome': ''
    },
    'profissional': {
      'profissional_nome': ''
    },
    'veiculo': {
      'veiculo_placa': ''
    },
    'check_moto_data': '',
    'check_moto_turno': '',
    'check_moto_justificativa': '',
    'check_moto_quilometragem': '',
    'check_moto_combustivel': '',
    'check_moto_oleo_motor': '',
    'check_moto_oleo_motor_obs': '',
    'check_moto_corrente': '',
    'check_moto_corrente_obs': '',
    'check_moto_freio': '',
    'check_moto_freio_obs': '',
    'check_moto_pneus': '',
    'check_moto_pneus_obs': '',
    'check_moto_retrovisor_dir': '',
    'check_moto_retrovisor_dir_obs': '',
    'check_moto_retrovisor_esq'  : '',
    'check_moto_retrovisor_esq_obs': '',
    'check_moto_meia_luz': '',
    'check_moto_meia_luz_obs': '',
    'check_moto_luz_baixa': '',
    'check_moto_luz_baixa_obs': '',
    'check_moto_luz_alta': '',
    'check_moto_luz_alta_obs': '',
    'check_moto_pisca_direito': '',
    'check_moto_pisca_direito_obs': '',
    'check_moto_pisca_esquerdo': '',
    'check_moto_pisca_esquerdo_obs': '',
    'check_moto_partida': '',
    'check_moto_partida_obs': '',
    'check_moto_luz_freio': '',
    'check_moto_luz_freio_obs': '',
    'check_moto_lanterna_tra': '',
    'check_moto_lanterna_tra_obs': '',
    'check_moto_sirene': '',
    'check_moto_sirene_obs': '',
    'check_moto_buzina': '',
    'check_moto_buzina_obs': '',
    'check_moto_giroflex': '',
    'check_moto_giroflex_obs': '',
    'check_moto_estrobo': '',
    'check_moto_estrobo_obs': '',
    'check_moto_capacete': '',
    'check_moto_capacete_obs': '',
    'check_moto_joelheira': '',
    'check_moto_joelheira_obs': '',
    'check_moto_cotoveleira': '',
    'check_moto_cotoveleira_obs': '',
    'check_moto_luvas': '',
    'check_moto_luvas_obs': '',
    'check_moto_botas': '',
    'check_moto_botas_obs': '',
    'check_moto_colete': '',
    'check_moto_colete_obs': '',
    'check_moto_jaqueta': '',
    'check_moto_jaqueta_obs': '',
    'check_moto_capa': '',
    'check_moto_capa_obs': '',
    'check_moto_documento': '',
    'check_moto_documento_obs': '',
    'check_moto_cartao_abastecimento': '',
    'check_moto_cartao_abastecimento_obs': '',
    'check_moto_gps': '',
    'check_moto_gps_obs': '',
    'check_moto_celular': '',
    'check_moto_celular_obs': '',
    'check_moto_registro': '',
  };

  constructor(
    private route: ActivatedRoute,
    private checkMotoSvc: CheckMotoService) { }

  ngOnInit() {
    this.route.params.subscribe( params => {
			if (params.id) {
				this.checkMotoSvc.getCheckMoto(params.id).then((data: any) => {
          data.check_moto_data = moment(data.check_moto_data, 'YYYY-MM-DD').format('DD/MM/YYYY');
          this.checklist = data;

          let html = "<h3>CHECK-LIST CHRONOS FROTA - MOTO</h3> ";


                

          html += "   <!-- TURNO --> ";
          html += "   <div class='panel1 panel-inverse1 box1'> ";
          html += "     <div class='panel-heading'> ";
          html += "       <h4 class='panel-title'>Turno</h4> ";
          html += "     </div> ";
          html += "     <div class='panel-body'> ";
          html += "       <div class='row'> ";
          html += "         <div class='col-md-2'> ";
          html += "           <div class='form-group'> ";
          html += "             <label>Data turno: " + this.checklist.check_moto_data + "</label> ";
          html += "           </div> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "       <div class='row'> ";
          html += "         <div class='col-md-4'>"; 
          html += "           <div class='form-group'> ";
          html += "             <label>Periodo: " + this.checklist.check_moto_turno == 'D' ? 'Diurno' : 'Noturno' + "</label> ";
          html += "           </div> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "       <div class='row'> ";
          html += "         <div class='col-md-12'> ";
          html += "           <div class='form-group'> ";
          html += "             <label>Justificativa: " + this.formatNull(this.checklist.check_moto_justificativa) + "</label> ";
          html += "           </div> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "     </div> ";
          html += "   </div> ";
          html += "   <!-- TURNO END --> ";
          html += "   <!-- LOCALIZACAO --> ";
          html += "   <div class='panel1 panel-inverse1 box1'> ";
          html += "     <div class='panel-heading'> ";
          html += "       <h4 class='panel-title'>Localização</h4> ";
          html += "     </div> ";
          html += "     <div class='panel-body'> ";
          html += "       <div class='row'> ";
          html += "         <div class='col-md-4'> ";
          html += "           <div class='form-group'> ";
          html += "             <label>Central: " + this.checklist.cliente.cliente_nome + "</label> ";
          html += "           </div> ";
          html += "         </div> ";
          html += "         <div class='col-md-4'> ";
          html += "           <div class='form-group'> ";
          html += "             <label>Unidade/base: " + this.checklist.unidade.unidade_nome + "</label> ";
          html += "           </div> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "       <div class='row'> ";
          html += "         <div class='col-md-8'> ";
          html += "           <div class='form-group'> ";
          html += "             <label>Profissional: " + this.checklist.profissional.profissional_nome + "</label> ";
          html += "           </div> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "     </div> ";
          html += "   </div> ";
          html += "   <!-- ------------------------------- --> ";
          html += "   <!-- VEICULO --> ";
          html += "   <div class='panel1 panel-inverse1 box1'> ";
          html += "     <div class='panel-heading'> ";
          html += "       <h4 class='panel-title'>Veículo</h4> ";
          html += "     </div> ";
          html += "     <div class='panel-body'> ";
          html += "       <div class='row'> ";
          html += "         <div class='col-md-4'> ";
          html += "           <div class='form-group'> ";
          html += "             <label>Veículo: " + this.checklist.veiculo.veiculo_placa + "</label> ";
          html += "           </div> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "       <div class='row'> ";
          html += "         <div class='col-md-4'> ";
          html += "           <div class='form-group'> ";
          html += "             <label>Quilometragem: " + this.mascaraKm(this.checklist.check_moto_quilometragem) + "</label> ";
          html += "           </div> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "       <div class='row'> ";
          html += "         <div class='col-md-4'> ";
          html += "           <label>Nível combustível: " + this.formatDataCombustivel(this.checklist.check_moto_combustivel) + "</label> ";
          html += "         </div> ";
          html += "       </div> ";
          html += "     </div> ";
          html += "   </div> ";
          html += "   <!-- ------------------------------- --> ";
          html += "   <div class='panel1 panel-inverse1 box1'> ";
          html += "     <div class='panel-heading'> ";
          html += "       <h4 class='panel-title'>Mecânica</h4> ";
          html += "     </div> ";
          html += "     <div class='panel-body'> ";
          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Óleo do motor:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_oleo_motor) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_oleo_motor_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Corrente:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_corrente) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_corrente_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Freio:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_freio) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_freio_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui      
          
          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Pneus:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_pneus) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_pneus_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui            


          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Retrovisor direito:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_retrovisor_dir) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_retrovisor_dir_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui           
          
          
          
          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Retrovisor esquerdo:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_retrovisor_esq) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_retrovisor_esq_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui     


          html += "     </div> ";
          html += "   </div> ";
          html += "   <!--  --> ";
          html += "   <div class='panel1 panel-inverse1 box1'> ";
          html += "     <div class='panel-heading'> ";
          html += "       <h4 class='panel-title'>Elétrico</h4> ";
          html += "     </div> ";
          html += "     <div class='panel-body'> ";


          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>1/2 Luz:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_meia_luz) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_meia_luz_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui     

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Luz baixa:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_luz_baixa) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_luz_baixa_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Luz alta:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_luz_alta) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_luz_alta_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui         
          
          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Pisca direito:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_pisca_direito) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_pisca_direito_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Pisca esquerdo:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_pisca_esquerdo) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_pisca_esquerdo_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui            


          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Partida:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_partida) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_partida_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui     

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Luz de freio:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_luz_freio) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_luz_freio_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui     


          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Lanterna traseira:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_lanterna_tra) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_lanterna_tra_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Sirene:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_sirene) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_sirene_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Buzina:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_buzina) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_buzina_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  


          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Giroflex:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_giroflex) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_giroflex_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Estrobo:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_estrobo) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_estrobo_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     </div>";
          html += "   </div>";
          html += "   <div class='panel1 panel-inverse1 box1'>";
          html += "     <div class='panel-heading'>";
          html += "       <h4 class='panel-title'>Equipamentos - EPI</h4>";
          html += "     </div>";
          html += "     <div class='panel-body'>";

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Capacete:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_capacete) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_capacete_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Joelheira:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_joelheira) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_joelheira_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  


          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Cotoveleira:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_cotoveleira) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_cotoveleira_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Luvas:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_luvas) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_luvas_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui            

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Botas:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_botas) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_botas_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui         
          
          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Colete:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_colete) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_colete_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  


          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Jaqueta de couro:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_jaqueta) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_jaqueta_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Capa de chuva:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_capa) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_capa_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui            

          html += "     </div>";
          html += "   </div>";
          html += "   <div class='panel1 panel-inverse1 box1'>";
          html += "     <div class='panel-heading'>";
          html += "       <h4 class='panel-title'>Itens obrigatórios</h4>";
          html += "     </div>";
          html += "     <div class='panel-body'>";

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Documento:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_documento) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_documento_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui         
          
          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Cartão de abastecimento:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_cartao_abastecimento) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_cartao_abastecimento_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui     

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>GPS:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_gps) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_gps_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui  

          html += "     <div class='row'>"; //aqui
          html += "       <div class='col-xs-2'>";
          html += "         <div>";
          html += "           <label>Celular:</label>";
          html += "         </div>";
          html += "       </div>";
          html += "       <div class='col-xs-1'>";
          html += "         " + this.formatDataSimNao(this.checklist.check_moto_celular) + "";
          html += "       </div>";
          html += "       <div class='col-xs-7' >";
          html += "         <b>Obs.:</b> " + this.formatNull(this.checklist.check_moto_celular_obs) + "";
          html += "       </div>";
          html += "     </div>"; //aqui            


          html += "     </div>";
          html += "   </div>";


          document.getElementById("sidebar").style.display = "none";
          document.getElementById('imprimir_checklist').innerHTML = html;
          window.print();
          document.getElementById("sidebar").style.display = "block";          

				});
			}
		});
  }

  formatNull(obj){

    if(obj == null){
      obj = "";
    }

    return obj;
  }


  formatDataSimNao(data){
    switch(data){
      case 'S':
        return 'Sim';
      case 'N':
        return 'Não';
      default:
        return ''; 
    }
  }

  formatDataCombustivel(data){
    switch(data){
      case 'CH':
        return 'Cheio';
      case '34':
        return '3/4';
      case '12':
        return '1/2';
      case '14':
        return '1/4';
      case 'ND':
        return '0';
      default:
        return '';
    }
  }

  
  mascaraKm(valor){

		if(valor != "" && valor != null){

			if(valor.length <= 3){
				return valor;
			}else{

				if(valor.indexOf(".") != -1){

					var sValor = valor.split(".");
					if(sValor[1] == "000"){
						return sValor[0];
					}else{
						return sValor[0] + sValor[1];
					}

				}

			}

		}

	  }


}
